const TWEEN = require("@tweenjs/tween.js");

export const moveObject = (object, position, options) => {
  const { duration, delay, easing } = options;

  position.x = position.x || object.position.x;
  position.y = position.y || object.position.y;
  position.z = position.z || object.position.z;

  new TWEEN.Tween(object)
    .to({ position }, duration || 1000)
    .easing(easing || TWEEN.Easing.Quadratic.InOut)
    .delay(delay || 0)
    .start();
};

export const rotateObject = (object, rotation, options) => {
  const { duration, delay, easing } = options;

  rotation.x = rotation.x || object.rotation.x;
  rotation.y = rotation.y || object.rotation.y;
  rotation.z = rotation.z || object.rotation.z;

  new TWEEN.Tween(object)
    .to({ rotation }, duration || 1000)
    .easing(easing || TWEEN.Easing.Quadratic.InOut)
    .delay(delay || 0)
    .start();
};
